<template>
  <div>
    <div
      class="inline-block relative cursor-pointer px-1"
      :class="{
        resolved: !hasUnresolvedQuarantinedImages,
        unresolved: hasUnresolvedQuarantinedImages,
      }"
    >
      <!-- <span v-if="!hasUnresolvedQuarantinedImages"> ✔ </span>
      <span v-else> ✖ </span> -->
      <slot></slot>
    </div>
    <div class="text-base-content/60 ml-5">
      {{
        hasUnresolvedQuarantinedImages
          ? `Quarantine reason: ${quarantineReasonList.join(', ')}`
          : ''
      }}
      <!-- {{ imagesWillBeRemoved ? ' Quarantined images in this series will be removed.' : '' }} -->
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Series from './types/Series';

const props = defineProps<{
  series: Series;
}>();

const unresolvedQuarantinedImages = computed(() => {
  const quarantinedImages = props.series.instances.filter(
    (i) => i.quarantine && !i.quarantine.attestNoPHI
  );
  return quarantinedImages;
});

const hasUnresolvedQuarantinedImages = computed(() => {
  return unresolvedQuarantinedImages.value.length > 0;
});

const quarantineReasonList = computed(() => {
  const reasons = unresolvedQuarantinedImages.value.map((i) => i.quarantine && i.quarantine.reason);
  return [...new Set(reasons)];
});

// const imagesWillBeRemoved = computed(() => {
//   return (
//     props.series.instances.findIndex((i) => i.quarantine && i.quarantine.action === 'remove') > -1
//   );
// });
</script>

<style scoped>
.resolved {
  background-color: color-mix(in oklab, var(--color-success) 30%, transparent);
}
.resolved:hover {
  background-color: color-mix(in oklab, var(--color-success) 45%, transparent);
}
.unresolved {
  background-color: color-mix(in oklab, var(--color-error) 30%, transparent);
}
.unresolved:hover {
  background-color: color-mix(in oklab, var(--color-error) 45%, transparent);
}
</style>
